// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__kdOTf","title":"styles_title__SRYPX"};